/* esm.sh - rxjs@7.8.2/dist/esm/internal/util/SequenceError */
import{createErrorClass as o}from"rxjs/dist/esm/internal/util/createErrorClass";var n=o(r=>function(e){r(this),this.name="SequenceError",this.message=e});export{n as SequenceError};
//# sourceMappingURL=SequenceError.mjs.map